import { render } from "./OrderInfoDialog.vue?vue&type=template&id=6057e2bd&scoped=true&ts=true"
import script from "./OrderInfoDialog.vue?vue&type=script&lang=ts"
export * from "./OrderInfoDialog.vue?vue&type=script&lang=ts"

import "./OrderInfoDialog.vue?vue&type=style&index=0&id=6057e2bd&lang=less&scoped=true"

import exportComponent from "/builds/toyota/bo/merchant-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6057e2bd"]])

export default __exports__